import { FlagCategory } from '../services/emission-calculation/emission-calculation.model';

export const FLAG_CATEGORY_OPTIONS: { value: FlagCategory; label: string }[] = [
  { value: 'AGRICULTURE', label: 'Agriculture' },
  { value: 'FORESTRY', label: 'Forestry' },
  { value: 'LAND_USE_CHANGE', label: 'Land use change' },
  { value: 'LAND_MANAGEMENT', label: 'Land management' },
  { value: 'REMOVALS', label: 'Removals' },
];

/** Label for a stored flagCategory; falls back to a de-underscored value for anything unrecognised. */
export const formatFlagCategoryDisplay = (value: string | null | undefined): string => {
  if (value == null || value === '') return '—';
  const opt = FLAG_CATEGORY_OPTIONS.find((o) => o.value === value);
  return opt?.label ?? String(value).replace(/_/g, ' ');
};

/**
 * The FLAG classification is stored as two fields (`isFlag` and `flagCategory`) but there is
 * only one decision to make, so a single control offers it: "Not FLAG-related" or a category.
 * That also makes the contradictory pair unrepresentable, where a checkbox plus a dependent
 * dropdown let a category survive being un-flagged.
 *
 * One state cannot be expressed by a category alone: an import may set the classification
 * without a category. It gets its own value so opening such a record and saving it again
 * cannot silently drop the classification, and it is only ever offered to a record already
 * in that state.
 */
export const FLAG_NO_CATEGORY_VALUE = '__FLAG_NO_CATEGORY__';

/** The single control's value, from the stored pair. */
export const flagSelectValueFrom = (
  isFlag: boolean | null | undefined,
  flagCategory: string | null | undefined,
): string => {
  if (flagCategory) return flagCategory;
  return isFlag ? FLAG_NO_CATEGORY_VALUE : '';
};

/** The stored pair, from the single control's value. */
export const flagFieldsFromSelectValue = (
  value: string,
): { isFlag: boolean; flagCategory: string } => {
  if (value === FLAG_NO_CATEGORY_VALUE) return { isFlag: true, flagCategory: '' };
  return { isFlag: Boolean(value), flagCategory: value };
};
